export default __webpack_public_path__ + "static/media/teaching_material.745f42c3.png";